import React from "react";
import { LabelForm } from "../form";
import { ToggleSwitch } from "flowbite-react";
import tenkenTheme from "../../configs/themes/tenkenTheme";

const PositionToggle = ({ checked, handleChangeModal, fieldName }) => {
  const isChecked = checked === 9 ? true : false;
  return (
    <div className="flex items-center w-full">
      <LabelForm
        className="inline-block mr-2 cursor-pointer"
        text="無"
        onClick={() => handleChangeModal(fieldName, 0)}
      />
      <ToggleSwitch
        theme={tenkenTheme}
        color="primary"
        checked={isChecked}
        onChange={() => handleChangeModal(fieldName, !isChecked)}
      />
      <LabelForm
        className="inline-block ml-2 cursor-pointer"
        text="有"
        onClick={() => handleChangeModal(fieldName, 9)}
      />
    </div>
  );
};

export default PositionToggle;
